import { call, put, all, takeLatest, select } from 'redux-saga/effects'
import { webApi } from 'lib/api'
import { errorWrap } from 'lib/saga-helpers'
import { constants, setField } from './actions'
import { MODAL_FROM_CONTEXTS, setUser, toggleModal } from 'store/ui/actions'
import { getNewToken } from 'store/ui/sagas'
import * as analytics from 'lib/analytics'
import { fetchDropDownNotificationItems, fetchNotifications } from '../notifications/actions'

export const selectors = {
  modalFromContext: ({ ui }) => ui.modalFromContext,
  validPassword: ({ loginModal }) => loginModal.mode === 'login' || (
    loginModal.password.value === loginModal.repeatPassword.value
  )
}

function * submit ({ payload: { mode, fields: { name, email, password }, history } }) {
  const [
    modalFromContext,
    validPassword
  ] = yield all([
    select(selectors.modalFromContext),
    select(selectors.validPassword)
  ])

  if (!validPassword) {
    yield put({
      type: constants.SUBMIT_FAILURE,
      payload: {
        field: 'password',
        error: 'Passwords must match'
      }
    })
    return
  }

  const { localStorage } = window
  const sharedBy = localStorage?.getItem('sharedBy')

  const endpoints = {
    register: '/users/register',
    login: '/users/login'
  }
  const payloads = {
    login: {
      email,
      password
    },
    register: {
      name,
      email,
      password,
      sharedBy
    }
  }
  const { data: user } = yield call(webApi.post, endpoints[mode], payloads[mode])

  yield getNewToken()
  yield put(setUser(user))
  yield put(fetchNotifications({}))
  yield put(fetchDropDownNotificationItems())
  if (modalFromContext === MODAL_FROM_CONTEXTS.REFERENCE_CHECK) {
    yield put(toggleModal('login', false))
    yield put(toggleModal('referenceCheck'))
  } else {
    yield put(toggleModal('login', false))
  }
  yield put({
    type: constants.SUBMIT_SUCCESS
  })

  if (mode === 'register') {
    history.push(`/users/${user.slug}/welcome`)
    analytics.event({
      category: 'User',
      action: analytics.SIGNUP_ACTIONS.CREATED_ACCOUNT
    })
  } else if (mode === 'login') {
    analytics.event({
      category: 'User',
      action: 'Logged in'
    })
  }
}

export default function * rootSaga () {
  yield takeLatest(
    constants.SUBMIT,
    errorWrap(submit, constants.SUBMIT_FAILURE, function * (e, { payload: { mode, fields, fields: { name, email, password } } }) {
      const errorType = e?.response?.data?.type
      const errorField = e?.response?.data?.details?.[0]?.path?.[0]
      const errorMessage = e?.response?.data?.details?.[0]?.message
      const errorStatus = e?.response?.status

      if (errorType === 'emailexists') {
        yield put(setField('email', email, { message: 'User with that email already exists, please try to login' }))
      } else if (errorStatus === 404) {
        yield put(setField('email', email, { message: 'No user with that email. Please try to sign up instead' }))
      } else if (errorStatus === 403) {
        yield put(setField('password', password, { message: 'Wrong password' }))
      } else if (errorStatus === 401) {
        yield put(setField('email', email, { message: 'User with that email must use gmail, facebook, or ORCID sign in' }))
      } else if (!errorType && errorStatus === 409) {
        yield put(setField('email', email, { message: 'User with that email already exists, please try to login' }))
      }

      if (errorType === 'user_schema_validation' && errorField) {
        yield put(setField(errorField, fields[errorField], { message: errorMessage.replace(/"/g, '') }))
      }

      if (!errorType && errorStatus === 500) {
        yield put(setField('email', email, { message: `Failed to ${mode} please try again with a different login method` }))
      }
    })
  )
}
